// extracted by mini-css-extract-plugin
module.exports = {"enter":"authTransition_enter__2NvAE","enterActive":"authTransition_enterActive__2B1bI","exit":"authTransition_exit__2YL4O","exitActive":"authTransition_exitActive__1B6Ht"};